import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useTrials from '@/hooks/data/useTrials';
import TrialContext, { ITrialContext } from '@/contexts/data/TrialContext';
import IsLoading from '@/components/layouts/IsLoading';
import { useMatch, useParams } from 'react-router-dom';
import TrialsContext from '@/contexts/data/TrialsContext';
import useConfigurationTrial from '@/hooks/data/useConfigurationTrial';
import ConfigurationTrialContext from '@/contexts/data/ConfigurationTrialContext';


export interface ITrialProviderProps {
}

export const TrialProvider: FC<PropsWithChildren<ITrialProviderProps>> = ({ children }) => {
    const trials = useContext(TrialsContext);

    const trialOid = useParams()?.trialOid;

    const trial  = useMemo(() => {
        if (!trialOid) {
            return {
                data: undefined,
                error: undefined,
                loading: false,
                validating: false,
                refresh: async () => {
                    return undefined;
                },
            } as ITrialContext;
        }

        return {
            data: trials.data?.find(x => x.oid === trialOid),
            oid: trialOid,
            error: trials.error,
            loading: trials.loading,
            validating: trials.validating,
            refresh: async () => {
                const newData = await trials.refresh();

                return newData?.find(x => x.oid === trialOid);
            },
        } as ITrialContext
    }, [trials, trialOid]);

    const configurationTrial = useConfigurationTrial(trial?.data?.id ? { trialId: trial?.data?.id } : undefined);

    return (

        <TrialContext.Provider value={trial}>
            <ConfigurationTrialContext.Provider value={configurationTrial}>
                <IsLoading name="trial" loading={trial.loading} validating={trial.validating}/>
                <IsLoading name="configuration-trial" loading={configurationTrial.loading} validating={configurationTrial.validating}/>
                {children}
            </ConfigurationTrialContext.Provider>
        </TrialContext.Provider>
    );
}

export default TrialProvider;
